
export function activate(target){
    if(target){
        target.classList.add('active');
    }else{
        return false
    }
}
export function deactivate(target){
    if(target){
    target.classList.remove('active');
    }else{
        return false
    }
}
export function disable(target){
    if(target){
    target.setAttribute('disabled','');
    }else{
        return false
    }
}
export function available(target){
    if(target){
    target.removeAttribute('disabled');
    }else{
        return false
    }
}